'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
var index = require('../../node_modules/react-stripe-elements/es/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var robotoFont = {
  family: 'Roboto',
  style: 'normal',
  weight: '400',
  src: "local('Roboto'), local('Roboto-Regular'), url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.woff2) format('woff2')",
  unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
};
function withStripe() {
  return function (WrappedComponent) {
    var WrappedComponentContainer = index.injectStripe(WrappedComponent);

    var WrappedComponentWithStripe =
    /*#__PURE__*/
    function (_PureComponent) {
      inherits(WrappedComponentWithStripe, _PureComponent);

      function WrappedComponentWithStripe(props) {
        var _this;

        classCallCheck(this, WrappedComponentWithStripe);

        _this = possibleConstructorReturn(this, getPrototypeOf(WrappedComponentWithStripe).call(this, props));
        _this.state = {
          stripe: null
        };
        return _this;
      }

      createClass(WrappedComponentWithStripe, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (window.Stripe) {
            this.setState({
              stripe: window.Stripe(this.props.stripeKey)
            });
          } else {
            document.querySelector('#stripe-js').addEventListener('load', function () {
              _this2.setState({
                stripe: window.Stripe(_this2.props.stripeKey)
              });
            });
          }
        }
      }, {
        key: "render",
        value: function render() {
          return React__default["default"].createElement(index.StripeProvider, {
            stripe: this.state.stripe
          }, React__default["default"].createElement(index.Elements, {
            fonts: [robotoFont]
          }, React__default["default"].createElement(WrappedComponentContainer, this.props)));
        }
      }]);

      return WrappedComponentWithStripe;
    }(React.PureComponent);

    return WrappedComponentWithStripe;
  };
}

exports.withStripe = withStripe;
